import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });
export const PORTAL_TOKEN_KEY = "fasnet_portal_token";
api.interceptors.request.use((cfg) => {
  if ((cfg.url || "").includes("/portal/")) {
    const t = localStorage.getItem(PORTAL_TOKEN_KEY);
    if (t) cfg.headers["X-Portal-Token"] = t;
  }
  if (window.location.pathname.startsWith("/voucherchat")) {
    const vt = localStorage.getItem("vc_token");
    if (vt) cfg.headers["X-VC-Token"] = vt;
  }
  return cfg;
});

export const rupiah = (n) => `Rp ${Number(n || 0).toLocaleString("id-ID")}`;

export const fmtDate = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

const BULAN = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
const DATE_RE = /\b(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?)?\b/g;
// Ubah semua tanggal ISO (2026-10-23 / 2026-10-23 18:26:20 / 2026-10-23T11:26:20Z) di dalam teks menjadi "23 Okt 2026 [18:26]"
export const humanTgl = (text) => {
  if (text === null || text === undefined) return text;
  return String(text).replace(DATE_RE, (m, y, mo, d, h, mi) => {
    const mon = BULAN[Number(mo) - 1];
    if (!mon || Number(d) < 1 || Number(d) > 31) return m;
    if (h !== undefined && /[TZ]|[+-]\d{2}:?\d{2}$/.test(m)) { const dt = new Date(m.includes("T") ? m : m.replace(" ", "T")); if (!isNaN(dt)) return fmtDateTime(dt.toISOString()); }
    return `${Number(d)} ${mon} ${y}${h !== undefined ? ` ${h}:${mi}` : ""}`;
  });
};

export const errMsg = (e) => {
  const detail = e?.response?.data?.detail;
  if (detail == null) {
    const data = e?.response?.data;
    if (typeof data === "string" && data.trim().startsWith("<")) {
      return "Server sibuk atau tidak dapat dihubungi. Coba lagi.";
    }
    return e?.message || "Terjadi kesalahan";
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(detail);
};

export const ruleCommissions = (agents, sellerCode, total) => {
  const seller = agents.find((a) => a.code === sellerCode);
  return ((seller && seller.commission_rules) || [])
    .map((r) => ({
      agent_code: r.agent_code,
      agent_name: agents.find((x) => x.code === r.agent_code)?.name || "",
      amount: r.type === "percent" ? Math.floor((total * r.value) / 100) : r.value,
    }))
    .filter((c) => c.amount > 0);
};
